import { getAuthToken } from "../utils/commonHelper";
import axiosInstance from "../utils/AxiosInstance";

const API_URL = `${process.env.REACT_APP_API_URL}/article`; // Replace with your actual API URL


// Fetch all articles with pagination
export const fetchArticleTable = async (page: number, limit: number) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(`${API_URL}/table?page=${page}&limit=${limit}`, { headers: customHeaders });
  return response.data;
};

// Fetch all articles
export const fetchArticles = async () => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(API_URL, { headers: customHeaders });
  return response.data;
};

// Fetch an article by ID
export const fetchArticleById = async (id: string) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(`${API_URL}/${id}`, { headers: customHeaders });
  return response.data;
};

// Create a new article
export const addArticle = async (newArticle: { title: string; content: string; author: string; status: string; folder_name: string; photo?: string }) => {
  const response = await axiosInstance.post(API_URL, newArticle, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${getAuthToken()}`
    }
  });
  return response.data;
};

// Edit an existing article
export const updateArticle = async (id: string, updatedArticle: { title: string; content: string; author: string; status: string; folder_name: string; photo?: string }) => {
  const response = await axiosInstance.put(`${API_URL}/${id}`, updatedArticle, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${getAuthToken()}`
    }
  });
  return response.data;
};

// Delete an article
export const removeArticle = async (id: string) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.delete(`${API_URL}/${id}`, { headers: customHeaders });
  return response.data;
};
